/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import HardwareEntitiesRoutes from './hardware-entities.routes';
import HardwareEntitiesController from './hardware-entities.controller';

export default angular.module('tektelic.hardwareEntities', [])
    .config(HardwareEntitiesRoutes)
    .controller('HardwareEntitiesController', HardwareEntitiesController)
    .name;



// WEBPACK FOOTER //
// ./src/app/hardware-entities/index.js